import { render } from "./ExportForProcreate.vue?vue&type=template&id=d410ddd2&scoped=true"
import script from "./ExportForProcreate.vue?vue&type=script&lang=js"
export * from "./ExportForProcreate.vue?vue&type=script&lang=js"

import "./ExportForProcreate.vue?vue&type=style&index=0&id=d410ddd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d410ddd2"]])

export default __exports__